class Sidebar {
  constructor(config = {}) {
    this.title = config.title || '',
    this.content = config.content || '',
    this.data = config.data || []
  }

  updateProps(props) {
    this.DWRAbbrev = props.DWRAbbrev;
    this.StatName = props.StatName;
    return this;
  }

  getProps() {
    return {
      DWRAbbrev: this.DWRAbbrev,
      StatName: this.StatName
    }
  }

  updateTitle(title) {
    const $title = document.querySelector('.meta-data-display-container .tooltip-title');
    $title.innerHTML = `<i class="material-icons vertical-align-middle">location_on</i>${title}`;
    this.title = title;
    return this;
  }

  updateContent(content) {
    const $content = document.querySelector('.meta-data-display-container .tooltip-content');
    $content.innerHTML = content;
    this.content = content;
    return this;
  }
}
